import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React, { CSSProperties } from "react";
import Icon from 'features/shared/components/icons/Icon';
import styles from "./cardheader.module.scss";

interface IProps {
  title?: string;
  subtitle?: string;
  icon?: IconProp;
  iconColor?: string;
  background?: string;
  className?: string;
  actionBtns?: () => JSX.Element []
}

const CardHeader: React.FC<IProps> = (props) => {
  // helpers
  const getClasses = (className?: string) => {
    let passedClass = className !== undefined ? ` ${className}` : "";
    return `${styles.cardHeader}${passedClass}`;
  };

  const getBackground = (background?: string): CSSProperties | undefined => {
    if (background) {
      return {
        background: background
      }
    }
  };

  const getIconColor = (color?: string): CSSProperties | undefined => {
    if (color) {
      return {
        color: color
      }
    }
  };

  // render
  if (props.children) {
    return (
      <div className={getClasses(props.className)} style={getBackground(props.background)}>
        {props.children}
      </div>
    );
  } else {
    return (
      <div className={getClasses(props.className)} style={getBackground(props.background)}>
        <div className={styles.cardHeaderItem}>
          {props.icon !== undefined && 
            <span className="mr-2" style={getIconColor(props.iconColor)}>
              <Icon icon={props.icon}/>
            </span>
          }
          <h2 className={styles.cardTitle}>
            {props.title}
            {props.subtitle &&
              <small className="ml-2">{props.subtitle}</small>
            }
          </h2>
        </div>
        {props.actionBtns !== undefined && 
          <div className={styles.actionsItem}>
            {props.actionBtns()}
          </div>
        }
      </div>
    );
  }
  
};

export default CardHeader;